import { useParams } from "react-router-dom";
import { Avatar } from "../components/Avatar";
import { usePublicUser } from "../lib/api";

export function UserProfile() {
  const { uid = "" } = useParams();
  const { data: user, isLoading, isError } = usePublicUser(uid);

  if (isLoading) {
    return <div className="mt-20 text-center font-mono text-sm text-cyan-300/70">불러오는 중…</div>;
  }
  if (isError || !user) {
    return <div className="mt-20 text-center text-slate-400">사용자를 찾을 수 없습니다.</div>;
  }

  return (
    <section className="mx-auto max-w-lg fade-up">
      <div className="glass neon-border rounded-2xl p-7">
        <div className="flex items-center gap-4">
          <Avatar avatarUrl={user.avatarUrl} nickname={user.nickname} size={64} />
          <div>
            <h1 className="neon-text text-2xl font-bold">{user.nickname}</h1>
            <p className="mt-1 font-mono text-xs text-cyan-400/70">{user.role}</p>
          </div>
        </div>
        <p className="mt-4 whitespace-pre-wrap text-sm text-slate-300">
          {user.bio || "자기소개가 없습니다."}
        </p>
      </div>
    </section>
  );
}
